/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React from "react";
import PropTypes from "prop-types";
import { Link } from "@quintype/components";
import { useStateValue } from "../../SharedContext";
import get from "lodash.get";
import { getTextColor, isExternalStory, getStoryUrl } from "../../../utils/utils";

import "./headline.m.css";

export const Headline = ({ story, headerLevel }) => {
  const config = useStateValue() || {};
  const alternateHeadline = get(story, ["alternative", "home", "default", "headline"]);
  const headline = alternateHeadline || story.headline;
  const HeaderTag = "h" + headerLevel;

  const textColor = getTextColor(config.theme);
  return (
    <Link
      className="arrow-component arr--headline"
      href={getStoryUrl(story, `/${story.slug}`)}
      externalLink={isExternalStory(story)}>
      <HeaderTag styleName={` headline ${textColor}`}>{headline}</HeaderTag>
    </Link>
  );
};

Headline.propTypes = {
  /** The Story Object from the API response */
  story: PropTypes.object.isRequired,
  /** Header tags ranging h1-h6, where h[headerLevel] */
  headerLevel: PropTypes.string
};

Headline.defaultProps = {
  headerLevel: "6"
};
